<template>
  <div v-if="isAllowedHost" class="vk-login" :class="{ 'vk-login_disabled': disabled }">
    <div ref="vkContainer"></div>

    <div v-if="isLoaderLogin" class="vk-login__loader">
      <span class="vk-login__spinner"></span>
      Авторизация...
    </div>

    <div v-if="errorMessage" class="vk-login__error">
      <span class="vk-login__error-icon">!</span>
      <span class="vk-login__error-text">{{ errorMessage }}</span>
      <button type="button" class="vk-login__error-close" @click="errorMessage = null">&times;</button>
    </div>
  </div>
</template>

<script>
import config from "@/config.js";
import {mapMutations} from "vuex";

export default {
  name: 'VkLogin',

  props: {
    disabled: Boolean
  },

  data() {
    return {
      sdkLoaded: false,
      isLoaderLogin: false,
      errorMessage: null
    }
  },

  computed: {
    isAllowedHost() {
      return true;
    }
  },

  mounted() {
    if (this.isAllowedHost) {
      this.$nextTick(() => {
        this.initVkId()
      })
    }
  },

  methods: {
    ...mapMutations({
      'setUser': 'user/setUser',
      'setShowLoginModal': 'setShowLoginModal',
    }),

    initVkId() {
      if (!('VKIDSDK' in window)) {
        console.error('VKIDSDK not found')
        return
      }

      const VKID = window.VKIDSDK


      const oneTap = new VKID.OneTap()

      oneTap.render({
        container: this.$refs.vkContainer,
        fastAuthEnabled: false,
        showAlternativeLogin: true
      })
        .on(VKID.WidgetEvents.ERROR, this.onError)
        .on(VKID.OneTapInternalEvents.LOGIN_SUCCESS, (payload) => {
          const code = payload.code
          const deviceId = payload.device_id

          VKID.Auth.exchangeCode(code, deviceId)
            .then(this.onSuccess)
            .catch(this.onError)
        })

      this.sdkLoaded = true
    },

    onSuccess(data) {
      this.isLoaderLogin = true
      this.errorMessage = null
      this.$API.request.post(config.hostname + '/index.php?route=api/vkid/login', data).then((response) => {
        this.setUser(response.customer)
        this.setShowLoginModal(false)
      }).catch((error) => {
        this.errorMessage = error?.response?.data?.error || 'Произошла ошибка при авторизации'
      }).finally(() => {
        this.isLoaderLogin = false
      })
    },

    onError(error) {
      console.error('VK Auth error:', error)
      this.errorMessage = error?.message || 'Ошибка авторизации через ВКонтакте. Попробуйте другой способ'
    }
  },

}
</script>

<style scoped>
.vk-login {
  position: relative;
}

.vk-login_disabled {
  pointer-events: none;
  opacity: 0.5;
}

.vk-login__loader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  margin-top: 12px;
  background: #f5f5f5;
  border-radius: 8px;
  color: #666;
  font-size: 14px;
}

.vk-login__spinner {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-top-color: #0077ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.vk-login__error {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  margin-top: 12px;
  background: #fff2f2;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  color: #c62828;
  font-size: 14px;
  line-height: 1.4;
}

.vk-login__error-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: #c62828;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
}

.vk-login__error-text {
  flex: 1;
}

.vk-login__error-close {
  flex-shrink: 0;
  background: none;
  border: none;
  color: #c62828;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.vk-login__error-close:hover {
  opacity: 1;
}
</style>
